module.exports = __webpack_public_path__ + "img/close-icon.2e7c2c06.svg";